import React, { useState, useEffect } from 'react'

const FormatMoney = (props) => {
  const { num } = props
  let n = num


  let split = num.toFixed(2)
  let split2 = split.split('.')
  let afterdot = `.${split2[1]}`

  let str = n.toLocaleString('en-US')
  let splitstr = str.split('.')

  return splitstr[0] + afterdot
}
export default FormatMoney
